import { StateUtils } from '@spartacus/core';
import { PAYMENT_DELETE_PAYMENT } from '../payment-state';

export const DELETE_PAYMENT = '[Payment] Delete Payment';
export const DELETE_PAYMENT_SUCCESS = '[Payment] Delete Payment Success';
export const DELETE_PAYMENT_FAIL = '[Payment] Delete Payment Fail';
export const RESET_DELETE_PAYMENT = '[Payment] Reset Delete Payment';

export class DeletePayment extends StateUtils.LoaderLoadAction {
  readonly type = DELETE_PAYMENT;

  constructor(public payload: string) {
    super(PAYMENT_DELETE_PAYMENT);
  }
}

export class DeletePaymentSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = DELETE_PAYMENT_SUCCESS;

  constructor() {
    super(PAYMENT_DELETE_PAYMENT);
  }
}

export class DeletePaymentFail extends StateUtils.LoaderFailAction {
  readonly type = DELETE_PAYMENT_FAIL;

  constructor(public payload: unknown) {
    super(PAYMENT_DELETE_PAYMENT);
  }
}

export class ResetDeletePayment extends StateUtils.LoaderResetAction {
  readonly type = RESET_DELETE_PAYMENT;

  constructor() {
    super(PAYMENT_DELETE_PAYMENT);
  }
}

export type DeletePaymentActions = DeletePayment | DeletePaymentSuccess | DeletePaymentFail;
